// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2C5a4","content":"styles_content__3aTVY"};